import Vue from 'vue'

// axios
import axios from 'axios'
import useJwt from '@core/auth/jwt/useJwt'
import secureLs from './secureLs'
import secureCookies from './cookies'
import { initialAbility } from './acl/config'

const { jwt } = useJwt(axios, {})
const token = jwt.getToken()

const logoutAuthModule = () => new Promise(resolve => {
  const iframe = document.createElement('iframe')
  iframe.src = `${process.env.VUE_APP_BASE_AUTH_MODULE}/logout`
  iframe.width = '0'
  iframe.height = '0'
  iframe.style.display = 'none'

  const handleMessage = event => {
    console.log('event', event.data.type)
    if (event.data?.type === 'logout-success') {
      window.removeEventListener('message', handleMessage)
      iframe.remove()
      resolve()
    }
  }
  window.addEventListener('message', handleMessage)
  document.body.appendChild(iframe)

  // fallback kalau iframe gagal load / postMessage tidak pernah datang
  setTimeout(() => {
    window.removeEventListener('message', handleMessage)
    resolve()
  }, 2000)
})

const logoutAndRedirectToLoginPage = () => {
  secureLs.clearItem()
  secureCookies.clearItem()
  // window.location.replace('/login')
}

// instance for main komerce
const axiosIns = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 12000,
  headers: {
    'Application-Name': 'Web Komerce',
  },
})

const axiosAuthKompack = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 14000,
  headers: {
    'Application-Name': 'Web Komerce',
  },
})

const komshipAxiosIns = axios.create({
  // You can add your headers here
  headers: {
    Authorization: `Bearer ${token}`,
  },
  baseURL: process.env.VUE_APP_BASE_URL_KOMSHIP,
  timeout: 12000,
})

const komtimAxiosIns = axios.create({
  // You can add your headers here
  headers: {
    Authorization: `Bearer ${token}`,
  },
  baseURL: process.env.VUE_APP_BASE_URL_KOMTIM,
  timeout: 12000,
})

const kompackkomshipAxiosIns = axios.create({
  // You can add your headers here
  headers: {
    Authorization: `Bearer ${token}`,
  },
  baseURL: process.env.VUE_APP_BASE_URL_KOMPACKKOMSHIP_ADMIN,
  timeout: 14000,
})

const affiliateAxiosIns = axios.create({
  // You can add your headers here
  headers: {
    Authorization: `Bearer ${token}`,
  },
  baseURL: process.env.VUE_APP_BASE_URL_AFFILIATE,
  timeout: 12000,
})

const printService = axios.create({
  // You can add your headers here
  headers: {
    Authorization: `Bearer ${token}`,
  },
  baseURL: process.env.VUE_APP_PRINT_LABEL,
  timeout: 12000,
})

const axiosNoLimit = axios.create({
  headers: {
    Authorization: `Bearer ${token}`,
  },
  baseURL: process.env.VUE_APP_BASE_URL_KOMSHIP,
})

const newAxiosIns = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_NEW,
  headers: {
    Authorization: `Bearer ${token}`,
  },
})

const loginAxiosIns = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_NEW,
  timeout: 12000,
})

axiosIns.interceptors.response.use(
  response => response,
  async error => {
    // Do something with response error
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      await logoutAuthModule().then(() => logoutAndRedirectToLoginPage())
    }
    /* eslint-disable comma-dangle */
    return Promise.reject(error)
  }
)

axiosAuthKompack.interceptors.response.use(
  response => response,
  async error => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      await logoutAuthModule().then(() => logoutAndRedirectToLoginPage())
    }

    /* eslint-disable comma-dangle */
    return Promise.reject(error)
  }
)

komshipAxiosIns.interceptors.response.use(
  response => response,
  async error => {
    // Do something with response error
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      await logoutAuthModule().then(() => logoutAndRedirectToLoginPage())
    }

    /* eslint-disable comma-dangle */
    return Promise.reject(error)
  }
)

komtimAxiosIns.interceptors.response.use(
  response => response,
  async error => {
    // Do something with response error
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      await logoutAuthModule().then(() => logoutAndRedirectToLoginPage())
    }

    /* eslint-disable comma-dangle */
    return Promise.reject(error)
  }
)

kompackkomshipAxiosIns.interceptors.response.use(
  response => response,
  async error => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      await logoutAuthModule().then(() => logoutAndRedirectToLoginPage())
    }

    /* eslint-disable comma-dangle */
    return Promise.reject(error)
  }
)

affiliateAxiosIns.interceptors.response.use(
  response => response,
  async error => {
    // Do something with response error
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      await logoutAuthModule().then(() => logoutAndRedirectToLoginPage())
    }

    /* eslint-disable comma-dangle */
    return Promise.reject(error)
  }
)

axiosNoLimit.interceptors.response.use(
  response => response,
  async error => {
    // Do something with response error
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      await logoutAuthModule().then(() => logoutAndRedirectToLoginPage())
    }
    /* eslint-disable comma-dangle */
    return Promise.reject(error)
  }
)

newAxiosIns.interceptors.response.use(
  response => response,
  async error => {
    // Do something with response error
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      await logoutAuthModule().then(() => logoutAndRedirectToLoginPage())
    }
    /* eslint-disable comma-dangle */
    return Promise.reject(error)
  }
)

Vue.prototype.$http = axiosIns
Vue.prototype.$http_kompack = axiosAuthKompack
Vue.prototype.$http_kompack_kompship = kompackkomshipAxiosIns
Vue.prototype.$http_komship = komshipAxiosIns
Vue.prototype.$http_komtim = komtimAxiosIns
Vue.prototype.$http_komship_affiliate = affiliateAxiosIns
Vue.prototype.$http_print = printService
Vue.prototype.$http_no_limit = axiosNoLimit
Vue.prototype.$http_new = newAxiosIns

export {
  axiosAuthKompack,
  komshipAxiosIns,
  newAxiosIns,
  loginAxiosIns,
  komtimAxiosIns,
}
export default axiosIns
